import { useCallback, useState } from 'react';

// By default React Boundary does not catch errors thrown in async code.
// This hook allows us to throw errors in async code and catch them in a React Boundary.
export const useAsyncError = () => {
  const [, setError] = useState();

  const throwAsyncError = useCallback(
    (e: Error) => {
      setError(() => {
        throw e;
      });
    },
    [setError],
  );

  return { throwAsyncError };
};
